import { API_ROOT } from './.env'

export const upload = API_ROOT + 'upload';


// WEBPACK FOOTER //
// ./src/api/upload.js